'use strict';

//polyfills
require("babel-polyfill");
require("core-js/es6/map");
require("core-js/es6/set");
require("whatwg-fetch");
var _es6Promise = _interopRequireDefault(require("es6-promise"));
var _react = _interopRequireDefault(require("react"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var _reactRouterDom = require("react-router-dom");
var _history = require("history");
var _homePage = _interopRequireDefault(require("./components/home-page"));
var _notFound = _interopRequireDefault(require("./components/not-found"));
var _footer = _interopRequireDefault(require("./components/footer"));
var _menuList = _interopRequireDefault(require("./components/menu-list"));
var _metaNav = _interopRequireDefault(require("./components/meta-nav"));
var _metaNavMobile = _interopRequireDefault(require("./components/meta-nav-mobile"));
require("./lib/global-utils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
_es6Promise.default.polyfill();
var customHistory = (0, _history.createBrowserHistory)();
_reactDom.default.render( /*#__PURE__*/_react.default.createElement(_reactRouterDom.Router, {
  history: customHistory
}, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Switch, null, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
  exact: true,
  path: '/',
  component: _homePage.default
}), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
  component: _notFound.default
}))), document.getElementById('app'));
_reactDom.default.render( /*#__PURE__*/_react.default.createElement(_footer.default, null), document.getElementById('footer'));
_reactDom.default.render( /*#__PURE__*/_react.default.createElement(_menuList.default, null), document.getElementById('main-menu'));
_reactDom.default.render( /*#__PURE__*/_react.default.createElement(_metaNav.default, null), document.getElementById('meta-nav'));
_reactDom.default.render( /*#__PURE__*/_react.default.createElement(_metaNavMobile.default, null), document.getElementById('mobile-meta-nav'));

//Mobile Nav
var mobileNavTrigger = document.getElementById('mobile-nav-trigger'),
  target = document.querySelector('[data-menu]');
mobileNavTrigger.addEventListener('click', function () {
  if (mobileNavTrigger.classList.contains('is-open')) {
    target.classList.remove('is-open');
    mobileNavTrigger.classList.remove('is-open');
  } else {
    target.classList.add('is-open');
    mobileNavTrigger.classList.add('is-open');
  }
});


//////////////////
// WEBPACK FOOTER
// ./client/main.js
// module id = 175
// module chunks = 0